import { Controller } from "@hotwired/stimulus"

// Provides tabbed navigation functionality with sticky tabs and auto scrolling
//
// Connects to data-controller="dataset"

export default class extends Controller {
  static targets = ["datasetFilterSummary", "filters"]


  // TODO: these commented out methods are currently in the tabber controller
  // and should be moved here once data-controller="dataset" has been set on all
  // pages that use the dataset-with-filters and filter tabs have been removed
  // from existing tabbers

  // toggleFilters = (event) => {
  //   event.preventDefault()
  //   let toggleBtnElement = event.target
  //   if (toggleBtnElement.role !== 'button') {
  //     toggleBtnElement = event.target.closest('[role="button"]')
  //   }
  //   this.filtersTarget.ariaHidden = this.filtersVisible() ? 'true' : 'false'
  //   this.element.querySelectorAll('[data-action="click->tabber#toggleFilters"]').forEach((el) => {
  //     el.ariaExpanded = this.filtersVisible() ? 'true' : 'false'
  //   })
  // }

  // filtersVisible() {
  //   return this.filtersTarget.ariaHidden === 'false'
  // }

  datasetFilterSummaryTargetConnected() {
    this.filterSummaryOverContent = this.filterSummaryOverContent.bind(this)
    window.addEventListener("scroll", this.filterSummaryOverContent, { passive: true })
    this.filterSummaryOverContent() // Run on initial load
  }

  datasetFilterSummaryTargetDisconnected() {
    window.removeEventListener("scroll", this.filterSummaryOverContent)
  }

  filterSummaryOverContent() {
    const summary = this.datasetFilterSummaryTarget
    const parent = summary.offsetParent

    if (!parent) return

    const summaryTop = summary.getBoundingClientRect().top
    const parentTop = parent.getBoundingClientRect().top

    const distanceFromParentTop = summaryTop - parentTop

    if (distanceFromParentTop > 0) {
      summary.classList.add("over-content")
    } else {
      summary.classList.remove("over-content")
    }
  }
}
